import { API } from 'api';

import { ExternalGeoEvent, RequestedAck, User } from 'shared/types';

export const getAckedByUsers = (event: ExternalGeoEvent): string | null => {
  if (!event.requestedAcks?.length) return null;

  const allAcks = event.requestedAcks.flatMap((ack) => ack.acks || []);
  const ackedByUsers = new Set(
    allAcks.map((ack) => ack.userCreated.displayName),
  );

  return ackedByUsers.size ? [...ackedByUsers].join(', ') : null;
};

export const getNewestAckRequest = (
  event: ExternalGeoEvent,
): RequestedAck | null => {
  if (!event.requestedAcks?.length) return null;

  const sortedAcks = [...event.requestedAcks].sort((a, b) => b.id - a.id);
  return sortedAcks[0] ?? null;
};

export const getUserCanAck = (ackRequest: RequestedAck, user: User): boolean =>
  !ackRequest.acks?.some((ack) => ack.userCreated.id === user.id);

export const postAck = async (ackId: number): Promise<void> => {
  await API.post('signal_acks/acks/', { requestedAckId: ackId });
};
